<div class="container-fluid">
	<div class="row">

		<div class="col-lg-6 login-left d-flex">
			<div class="login-form">
				<div *ngIf="fromActivate" class="alert alert-success">{{ "register.attivazione_ok" | translate }}</div>
				<div *ngIf="false" class="btn-group" role="group" aria-label="Language">
					<img (click)="useLanguage(l.value)" class="ml-2 mr-2" style="width: 50px; cursor: pointer;"
						*ngFor="let l of listLanguages" src="assets/img/{{ l.img }}" />
				</div>
				<div id="logo" class="py-2">
					<a routerLink="dashboard">
						DS
					</a>
				</div>
				<h3 class="py-4">{{ "login.titolo" | translate }}</h3>
				<form [formGroup]="loginFormGroup" class="text-left">
					<div class="form-group">
						<itm-textbox [forceValidation]="forceValidation" formControlName="email"
							label="{{ 'login.email' | translate }}">
							{{ 'login.email_mancante_o_non_valida' | translate }}</itm-textbox>
					</div>
					<div class="form-group">
						<itm-textbox [forceValidation]="forceValidation" formControlName="password" type="password"
							cssClass="form-control-last" label="{{ 'login.password' | translate }}">
							{{ 'login.password_mancante' | translate }}
						</itm-textbox>
					</div>
					<div class="form-group">
						<itm-button (myClick)="onSubmit()" label="{{ 'login.accedi' | translate }}"
							cssClass="btn-primary btn-block">
						</itm-button>
						<small *ngIf="forceValidation && loginFormGroup.invalid" class="text-danger d-block">
							{{ 'common.verifica_i_campi_evidenziati' | translate }}
						</small>
					</div>

					<div class="form-group justify-content-between d-flex">
						<div class="form-check pl-0">
							<itm-checkbox formControlName="remember" label="{{ 'login.ricordami' | translate }}"></itm-checkbox>
						</div>

						<a id="password_dimenticata" class="py-2" (click)="forgotPassword()">{{ 'login.password_dimenticata' |
							translate }}?</a>
					</div>
					<div class="text-center d-flex row m-0">
						<hr class="col-2 col-md-3 p-0" /><span class="col p-0">{{ 'login.register' | translate }}?</span>
						<hr class="col-2 col-md-3 p-0" />
					</div>
					<div class="form-group">
						<itm-button (myClick)="register()" label="{{ 'login.registrati' | translate }}"
							cssClass="btn-light btn-block">
						</itm-button>
					</div>
					<div class="text-center"><small>v. web <strong>{{ versione }}</strong> | v. api <strong>{{ versioneBE }}</strong></small></div>
				</form>
			</div>

		</div>
		<div class="col login-right d-lg-flex d-none">
			<h3>{{ 'login.entra_nella_nostra_community' | translate }}</h3>
		</div>
	</div>
</div>